// Angular Files
import {
 Component, Input, Output, EventEmitter, ViewEncapsulation
} from '@angular/core';

export interface FooterLinkInterface {
    title: string;
    url: string;
}

export interface FooterEditEvent {
    field: string;
    value?: string;
    index?: number;
    event?: any;
    direction?: 'up' | 'down' | 'left' | 'right';
}

@Component({
    selector: 'public-footer',
    templateUrl: './public-portal-footer.component.html',
    styleUrls: ['./public-portal-footer.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    host: {
        class: 'footer'
    },
    standalone: false
})
export class PublicPortalFooterComponent {
    @Input() preview: boolean = false;

    @Input() footerLinks?: FooterLinkInterface[];

    // Edit mode inputs
    @Input() editMode: boolean = false;

    @Input() footerLinkTitleErrors: boolean[] = [];

    @Input() footerLinkUrlErrors: boolean[] = [];

    @Output() editChange = new EventEmitter<FooterEditEvent>();

    constructor() {}

    trackByFooterLink(index: number, item: FooterLinkInterface): number {
        // Use index for tracking to avoid issues when title/url changes during editing
        return index;
    }
}
